import React from 'react';

import { Grid } from '@material-ui/core';
import i18n from 'i18n';
import PageHeader from 'components/PageHeader';
import EnvironmentsCostCard from './EnvironmentsCostCard';
import FlavorsCostTable from './FlavorsCostTable';

const CostsPanel = () => {
  return (
    <>
      <PageHeader title={i18n.t('COSTS_PAGE.DASHBOARD_TITLE_KEY')} />
      <Grid container justify="center" alignItems="center">
        <Grid container spacing={2}>
          <FlavorsCostTable />
          <EnvironmentsCostCard />
        </Grid>
      </Grid>
    </>
  );
};

export default CostsPanel;
